import { render, staticRenderFns } from "./BlockForm.vue?vue&type=template&id=a2bc7ea8&scoped=true&"
import script from "./BlockForm.vue?vue&type=script&lang=js&"
export * from "./BlockForm.vue?vue&type=script&lang=js&"
import style0 from "./BlockForm.vue?vue&type=style&index=0&id=a2bc7ea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bc7ea8",
  null
  
)

export default component.exports